export const WIKI_LINKS = [
  {
    key: 'dashboard',
    docs: [
      {
        name: 'docs.dashboardMain',
        url: 'dashboard_statistics',
      },
    ],
  },
  {
    key: 'creative',
    docs: [
      {
        name: 'docs.creativeMain',
        url: 'creatives_where_to_start',
      },
      {
        name: 'docs.creativeDetailBanner',
        url: 'banner_creative',
        type: 'banner/new',
      },
      {
        name: 'docs.creativeDetailAudio',
        url: 'audio_creative',
        type: 'audio/new',
      },
      {
        name: 'docs.creativeDetailNative',
        url: 'native_creative',
        type: 'native/new',
      },
      {
        name: 'docs.creativeDetailVideo',
        url: 'video_cerative',
        type: 'video/new',
      },
      {
        name: 'docs.creativeModeration',
        url: 'creative_moderation',
        type: 'creativeModeration',
      },
    ],
  },
  {
    key: 'target',
    docs: [
      {
        name: 'docs.targetMain',
        url: 'targets_getting_started',
      },
      {
        name: 'docs.targetDetail',
        url: 'category/targets',
        type: 'target/new',
      },
    ],
  },
  {
    key: 'rule',
    docs: [
      {
        name: 'docs.ruleMain',
        url: 'rules_how_to_get_started',
      },
      {
        name: 'docs.ruleDetailCost',
        url: 'rules_cost',
        type: 'cost/new',
      },
      {
        name: 'docs.ruleDetailTarget',
        url: 'rules_target',
        type: 'target/new',
      },
    ],
  },
  {
    key: 'finance',
    docs: [
      {
        name: 'docs.financeMain',
        url: 'balance_management',
      },
    ],
  },
  {
    key: 'campaign',
    docs: [
      {
        name: 'docs.campaignMain',
        url: 'campaign_where_to_start',
      },
      {
        name: 'docs.campaignCreate',
        url: 'campaign_creation',
        type: 'campaign/new',
      },
    ],
  },
  {
    key: 'statistics',
    docs: [
      {
        name: 'docs.statisticMain',
        url: 'statistics_for_campaign_management',
      },
      {
        name: 'docs.statisticExport',
        url: 'export_statistics',
      },
    ],
  },
]
